import React from 'react';
import IconButton from 'material-ui/IconButton';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import NumberFormat from 'react-number-format';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { GridList, GridTile } from 'material-ui/GridList';
import {
    RadioButton,
    RadioButtonGroup,

} from 'material-ui/RadioButton';
import { Grid, Icon, DatePicker } from '../../components';

import {
    areaService,
    salaService,
    eventoService,
    subeventoService,
    apresentacaoService,
    tipoApresentacaoService,
    projetoStatusFinalService,
    Utils,
} from '../../services';
import PrincipalMaster from '../master/Principal';

class OrganizarApresentacao extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            areaSelecionada: 0,
            dsAreas: [],
            dsSalas: [],
            ano: '',
            eventoSelecionado: -1,
            dsEventos: [],
            dsSubeventos: [],
            dsApresentacoes: [],
            dsTipoApresentacao: [],
            dsProjetosClassificados: [],
            subeventoSelecionado: 0,
            tipoApresentacaoSelecionado: 0,
            salaSelecionada: 0,
            salaSelecionadaNome: '-',
            dataApresentacaoSelecionada: new Date(),
            horaInicioApresentacaoSelecionada: '19:30',
            horaTerminoApresentacaoSelecionada: '19:45',
        };
    }

    async componentWillMount() {
        const salas = await salaService.getAll({
            pageIndex: -1,
            rowsPerPage: 0,
            columnSort: 0,
            searchIndex: 0,
            orderSort: '',
            searchText: '',
            searchOperator: '=',
        });
        console.log(salas);
        const ano = new Date().getFullYear();
        const eventos = await eventoService.getEventosPeloAno(ano);

        this.setState({
            dsSalas: salas,
            ano,
            dsEventos: eventos,
        });
    }

    setSala(codigo, nome) {
        this.setState({
            salaSelecionada: codigo,
            salaSelecionadaNome: nome,
            areaSelecionada: 0,
            tipoApresentacaoSelecionado: 0,
            dsAreas: [],
        }, () => {
            this.buscarProjetosClassificados();
            this.buscarApresentacoesDefinidas();
        });
    }

    async setSubevento(subeventoCodigo) {
        const areas = await areaService.getAreasCoordenador(subeventoCodigo);
        this.setState({
            subeventoSelecionado: subeventoCodigo,
            areaSelecionada: 0,
            tipoApresentacaoSelecionado: 0,
            dsAreas: areas,
        }, () => {
            this.buscarProjetosClassificados();
            this.buscarApresentacoesDefinidas();
        });
    }

    async setTipoApresentacao(tipoApresentacaoCodigo) {
        this.setState({
            tipoApresentacaoSelecionado: tipoApresentacaoCodigo,
        }, () => {
            this.buscarApresentacoesDefinidas();
            this.buscarProjetosClassificados();
        });
    }

    async buscarEventosPeloAno() {
        let eventos = [];
        if (this.state.ano) {
            eventos = await eventoService.getEventosPeloAno(this.state.ano);
        }
        this.setState({
            dsEventos: eventos,
            eventoSelecionado: 0,
            subeventoSelecionado: 0,
            tipoApresentacaoSelecionado: 0,
        });
    }

    async buscarSubeventosPeloEvento(eventoCodigo) {
        this.setState({
            eventoSelecionado: eventoCodigo,
            subeventoSelecionado: 0,
            tipoApresentacaoSelecionado: 0,
        });

        const subeventos = await subeventoService.getSubeventosDoEvento(eventoCodigo);
        this.setState({ dsSubeventos: subeventos });
    }

    async buscarApresentacoesDefinidas() {
        const {
            subeventoSelecionado,
            tipoApresentacaoSelecionado,
            salaSelecionada,
            areaSelecionada,
        } = this.state;

        const apresentacoes = await apresentacaoService.getApresentacaoSala(subeventoSelecionado, tipoApresentacaoSelecionado, salaSelecionada, areaSelecionada);
        if (subeventoSelecionado !== 0) {
            const tipoApresentacao = await tipoApresentacaoService.getTiposApresentacao(subeventoSelecionado);
            this.setState({
                dsTipoApresentacao: tipoApresentacao,
            });
        }
        this.setState({
            dsApresentacoes: apresentacoes,
        });
    }

    async buscarProjetosClassificados() {
        const {
            subeventoSelecionado,
            tipoApresentacaoSelecionado,
            areaSelecionada,
        } = this.state;

        const projetosClassificados = await projetoStatusFinalService.getProjetosClassificacao(tipoApresentacaoSelecionado, subeventoSelecionado, areaSelecionada);

        this.setState({
            dsProjetosClassificados: projetosClassificados,
        });
    }

    async salvarLocalApresentacao(projeto) {
        try {
            const {
                salaSelecionada,
                dataApresentacaoSelecionada,
                horaInicioApresentacaoSelecionada,
                horaTerminoApresentacaoSelecionada,
            } = this.state;

            const response = await apresentacaoService.save({
                sala: salaSelecionada,
                projeto,
                horaInicio: horaInicioApresentacaoSelecionada,
                horaFim: horaTerminoApresentacaoSelecionada,
                dataApresentacao: dataApresentacaoSelecionada,
            });

            // atualiza grids
            this.buscarProjetosClassificados();
            this.buscarApresentacoesDefinidas();

            Utils.showToast(response.message);
        } catch (e) {
            Utils.showToast(e.message);
        }
    }

    async deletarApresentacao(projeto, sala) {
        try {
            const response = await apresentacaoService.delete({ projeto, sala });
            await this.buscarApresentacoesDefinidas();
            await this.buscarProjetosClassificados();

            Utils.showToast(response.message);
        } catch (e) {
            Utils.showToast(e.message);
        }
    }

    trabalhosPorSala() {
        const {
            salaSelecionada,
            eventoSelecionado,
            areaSelecionada,
        } = this.state;
        return projetoStatusFinalService.trabalhosPorSalaURL(salaSelecionada, eventoSelecionado, areaSelecionada);
    }

    fichaAvaliacaoPorSala() {
        const {
            salaSelecionada,
            eventoSelecionado,
            areaSelecionada,
        } = this.state;
        return projetoStatusFinalService.fichaAvaliacaoPorSalaURL(salaSelecionada, eventoSelecionado, areaSelecionada);
    }

    render() {
        const {
            areaSelecionada,
            dsAreas,
            dsSalas,
            dsApresentacoes,
            dsEventos,
            dsTipoApresentacao,
            dsSubeventos,
            ano,
            eventoSelecionado,
            subeventoSelecionado,
            tipoApresentacaoSelecionado,
            salaSelecionadaNome,
            dataApresentacaoSelecionada,
            dsProjetosClassificados,
            horaInicioApresentacaoSelecionada,
            horaTerminoApresentacaoSelecionada,
            salaSelecionada,
        } = this.state;

        return (
            <PrincipalMaster title="Organizar Apresentações" {...this.props}>

                <div style={{ width: '100%', display: 'table' }}>
                    <div className="padding-content" style={{ width: '25%', display: 'table-cell', borderRight: 'solid 1px #ccc' }}>
                        <h3>Selecione uma Sala</h3>
                        <Grid
                            ref={(ref) => { this.salasGridRef = ref; }}
                            stripedRows="true"
                            textTableEmpty="Nenhuma sala disponível"
                            dataSource={dsSalas}
                            showSearch={false}
                            columns={[
                                {
                                    text: 'Nome', name: 'NOME', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    name: (item) => {
                                        return (
                                            <div>
                                                <IconButton tooltip="Adicionar" onClick={() => this.setSala(item.CODIGO, item.NOME)}>
                                                    <Icon color="#007744" name="arrow_forward" />
                                                </IconButton>
                                            </div>
                                        );
                                    },
                                    width: '50px',
                                },
                            ]}
                        />
                    </div>

                    <div className="padding-content" style={{ width: '75%', display: 'table-cell' }}>
                        <h3>Trabalhos de: {salaSelecionadaNome}</h3>
                        <GridList cols={2} cellHeight="auto">
                            <GridTile cols={2}>
                                <NumberFormat
                                    format="####"
                                    customInput={TextField}
                                    required
                                    value={ano}
                                    errorText={ano ? '' : 'Campo obrigatório'}
                                    floatingLabelText="Ano"
                                    onBlur={() => this.buscarEventosPeloAno()}
                                    onChange={e => this.setState({ ano: e.target.value })}
                                />
                            </GridTile>
                            <GridTile cols={2}>
                                <SelectField
                                    floatingLabelText="Selecione um evento"
                                    value={eventoSelecionado}
                                    onChange={(_event, _index, value) => this.buscarSubeventosPeloEvento(value)}
                                    errorText={eventoSelecionado > 0 ? '' : 'Campo obrigatório'}
                                    fullWidth
                                >
                                    {
                                        dsEventos.map(evento => (
                                            <MenuItem key={evento.CODIGO} value={evento.CODIGO} primaryText={evento.NOME} />
                                        ))
                                    }
                                </SelectField>
                            </GridTile>
                            <GridTile cols={2}>
                                <SelectField
                                    floatingLabelText="Selecione um subevento"
                                    value={subeventoSelecionado}
                                    onChange={(_event, _index, value) => this.setSubevento(value)}
                                    fullWidth
                                >
                                    <MenuItem value={0} primaryText="Todos" />
                                    {
                                        dsSubeventos.map(subevento => (
                                            <MenuItem key={subevento.CODIGO} value={subevento.CODIGO} primaryText={subevento.NOME} />
                                        ))
                                    }
                                </SelectField>
                            </GridTile>
                            <GridTile cols={2}>
                                <SelectField
                                    floatingLabelText="Selecione uma área"
                                    value={areaSelecionada}
                                    onChange={(_event, _index, value) => {
                                        this.setState({ areaSelecionada: value }, () => {
                                            this.buscarProjetosClassificados();
                                            this.buscarApresentacoesDefinidas();
                                        })
                                    }}
                                    fullWidth
                                >
                                    <MenuItem value={0} primaryText="Todas" />
                                    {
                                        dsAreas.map(area => (
                                            <MenuItem key={area.CODIGO} value={area.CODIGO} primaryText={area.NOME} />
                                        ))
                                    }
                                </SelectField>
                            </GridTile>
                            <GridTile cols={1}>
                                <h4>Tipo de apresentação</h4>
                                {
                                    subeventoSelecionado > 0 ?
                                        <RadioButtonGroup
                                            name="tipoSubmissao"
                                            value={tipoApresentacaoSelecionado}
                                            defaultSelected={0}
                                            onChange={(_event, tipo) => this.setTipoApresentacao(tipo)}
                                        >
                                            <RadioButton value={0} label="Todos" />
                                            {
                                                dsTipoApresentacao.map(x => <RadioButton key={x.CODIGO} value={x.CODIGO} label={x.MODALIDADE} />)
                                            }
                                        </RadioButtonGroup> :
                                        <p>Selecione o subevento para ver os tipos de submissão.</p>
                                }
                            </GridTile>

                            <GridTile cols={1}>
                                <h4>Data da apresentação</h4>
                                {
                                    salaSelecionada > 0 ?
                                        <DatePicker
                                            value={dataApresentacaoSelecionada}
                                            onChange={date => this.setState({ dataApresentacaoSelecionada: date })}
                                            openToYearSelection="true"
                                            required="true"
                                            floatingLabelText="Data apresentação"
                                            errorText={dataApresentacaoSelecionada ? '' : 'Campo obrigatório'}
                                        />
                                        : <p>Selecione uma <b style={{ color: '#FF0000' }}>sala</b> para definir a data da apresentação .</p>
                                }
                            </GridTile>

                            <GridTile cols={1}>
                                <h4>Hora de início da apresentação</h4>
                                {
                                    salaSelecionada > 0 ?
                                        <TextField
                                            value={horaInicioApresentacaoSelecionada}
                                            label="Hora apresentação"
                                            format="##:##"
                                            defaultValue="19:30"
                                            onChange={e => this.setState({ horaInicioApresentacaoSelecionada: e.target.value })}
                                        />
                                        :
                                        <p>Selecione uma <b style={{ color: '#FF0000' }}>sala</b> para definir a hora de início da apresentação .</p>
                                }
                            </GridTile>

                            <GridTile cols={1}>
                                <h4>Hora de término da apresentação</h4>
                                {
                                    salaSelecionada > 0 ?
                                        <TextField
                                            value={horaTerminoApresentacaoSelecionada}
                                            label="Hora apresentação"
                                            format="##:##"
                                            onChange={e => this.setState({ horaTerminoApresentacaoSelecionada: e.target.value })}
                                            defaultValue="19:45"
                                        />
                                        :
                                        <p>Selecione uma <b style={{ color: '#FF0000' }}>sala</b> para definir a hora de término da apresentação .</p>
                                }
                            </GridTile>
                        </GridList>
                        <Grid
                            ref={(ref) => { this.projetosClassificadosGridRef = ref; }}
                            stripedRows="true"
                            textTableEmpty="Nenhuma apresentação nesta sala"
                            dataSource={dsProjetosClassificados}
                            showSearch={false}
                            columns={[
                                {
                                    text: 'Código', name: 'CODIGO2', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Projeto', name: 'TITULO', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Autores', name: 'AUTORES', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Área', name: 'AREA', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Modalidade', name: 'MODALIDADE', allowSort: true, allowSearch: true, searchOperator: 'LIKE', width:50,
                                },
                                {
                                    name: (item) => {
                                        return (
                                            <div>
                                                <IconButton tooltip="Salvar local da apresentação" onClick={() => this.salvarLocalApresentacao(item.CODIGO)} >
                                                    <Icon color="#007744" name="arrow_forward" />
                                                </IconButton>
                                            </div>
                                        );
                                    },
                                    width: '50px',
                                },
                            ]}
                        />

                    </div>
                </div>

                <div className="padding-content">
                    <h3>APRESENTAÇÕES DE: {salaSelecionadaNome}</h3>

                    <Grid
                        ref={(ref) => { this.apresentacoesGridRef = ref; }}
                        stripedRows="true"
                        textTableEmpty="Nenhuma apresentação nesta sala"
                        dataSource={dsApresentacoes}
                        showSearch={false}
                        columns={[
                            {
                                text: 'Código', name: 'CODIGO2', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Projeto', name: 'TITULO', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Autores', name: 'AUTORES', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Área', name: 'AREA', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Sala', name: 'SALA', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Data Apresentação', name: item => Utils.getFormatDate(item.DATAAPRESENTACAO), allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Início', name: item => item.HORAINICIO, allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                text: 'Fim', name: item => item.HORAFIM, allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                            },
                            {
                                name: (item) => {
                                    return (
                                        <div>
                                            <IconButton tooltip="Remover" onClick={() => this.deletarApresentacao(item.CODIGO, item.SALAS_CODIGO)} >
                                                <Icon color="#FF0000" name="close" />
                                            </IconButton>
                                        </div>
                                    );
                                },
                                width: '50px',
                            },
                        ]}
                    />
                    <div>
                        <RaisedButton
                            containerElement="a"
                            href={this.trabalhosPorSala()}
                            label="Lista de Trabalhos por Sala"
                            primary
                            target="_blank"
                        />
                        &nbsp;&nbsp;&nbsp;
                        <RaisedButton
                            containerElement="a"
                            label="Ficha de Avaliação por Sala"
                            secondary
                            href={this.fichaAvaliacaoPorSala()}
                            target="_blank"
                        />
                    </div>
                </div>
            </PrincipalMaster>
        );
    }
}

export default OrganizarApresentacao;
